import { render, staticRenderFns } from "./BannerMtLinkModal.vue?vue&type=template&id=a7558056&"
import script from "./BannerMtLinkModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BannerMtLinkModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7558056')) {
      api.createRecord('a7558056', component.options)
    } else {
      api.reload('a7558056', component.options)
    }
    module.hot.accept("./BannerMtLinkModal.vue?vue&type=template&id=a7558056&", function () {
      api.rerender('a7558056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BannerMtLink/components/BannerMtLinkModal.vue"
export default component.exports